<script lang="ts">
	//UI
	import MultiplePageLayout from "@hitit/hub/src/layouts/MultiplePageLayout.svelte";
	import ManageStoreItem from "./ManageStoreItem.svelte";
	import ManageOptions from "./ManageOptions.svelte";
	import ContainerLoading from "@hitit/hub/src/v7/components/common/ContainerLoading.svelte";

	//Utils
	import { navigate, Router, Route } from "svelte-routing";
	import { saveStatus } from "@hitit/hub/src/v7/store";
	import { t } from "@hitit/hub/src/stores";
	//Types
	//Props
	export let storeId = "";
	//Constants
	//Variables
	$: headerInfos = [
		{
			title: $t("global.product.Manage_Item"),
			clickEvent: () => navigate(`/store/${storeId}/product/item`),
			route: `/store/${storeId}/product/item/*`,
		},
		{
			title: $t("global.product.Manage_Option"),
			clickEvent: () => navigate(`/store/${storeId}/product/option`),
			route: `/store/${storeId}/product/option/*`,
		},
	];
	//Functions
	//Do

</script>

<MultiplePageLayout headerInfos={headerInfos}>
	{#if $saveStatus.options || $saveStatus.storeItems}
		<ContainerLoading>
			<p>{$t('global.saving_changes')}</p>
		</ContainerLoading>
	{/if}
	<Router>
		<Route path="/item">
			<ManageStoreItem storeId={storeId} />
		</Route>
		<Route path="/option">
			<ManageOptions storeId={storeId} />
		</Route>
	</Router>
</MultiplePageLayout>

<style lang="scss">
	p {
		font-size: 1.25rem;
		color: #46474b;
	}

</style>
